import { render } from "./ResultCount.vue?vue&type=template&id=f4529474&scoped=true"
import script from "./ResultCount.vue?vue&type=script&lang=js"
export * from "./ResultCount.vue?vue&type=script&lang=js"

import "./ResultCount.vue?vue&type=style&index=0&id=f4529474&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f4529474"

export default script